module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/feature_background-862066d4ffd992d373e66e06b2a8d1b9.png";